import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchShipping} from "../../../actions/shippingPage";

export const ShippingItemShippingMethod = ({fee, item, shippingMethod}) => {
  const dispatch = useDispatch();

  const {shippingMethodSelected, withdrawalPointsSelected} = useSelector(
    state => ({
      shippingMethodSelected: state.shippingReducer.payload.shippingMethodSelected || {},
      withdrawalPointsSelected: state.shippingReducer.payload.withdrawalPointsSelected || {},
    })
  );

  const onClick = (offerId, smId) => {
    let shippingMethods = {};

    if (fee.itemsCanBeGrouped) {
      for (const [key, sm] of Object.entries(shippingMethodSelected)) {
        const shippingMethodId = fee.shippingMethodId;
        // @ts-ignore
        if (sm.id === shippingMethodId) {
          shippingMethods[key] = {id: smId};
        }
      }
      shippingMethods = {...shippingMethodSelected, ...shippingMethods};
    } else {
      shippingMethods = {...shippingMethodSelected, [String(offerId)]: {id: smId}};
    }

    dispatch(fetchShipping(
      shippingMethods,
      Object.values(shippingMethods).includes(parseInt(Object.keys(withdrawalPointsSelected)[0])) ? withdrawalPointsSelected : {},
      null
      )
    );
  };

  return (
    <div
      className={`radio-pair-wrapper ${fee.shippingMethodId === shippingMethod.id ? 'radio-pair-wrapper__selected' : ''}`}>
      <div className="radio-pair">
        <input type="radio" id={`shipping-${item.offerId}-${shippingMethod.id}`}
               className={`input_shipping ${fee.itemsCanBeGrouped && fee.shippingMethodId === shippingMethod.id ? 'input_shipping_selected' : ''}`}
               name={`shipping_method_selected[${item.offerId}]`}
               defaultValue={shippingMethod.id}
               onClick={() => onClick(item.offerId, shippingMethod.id)}
               disabled={fee.shippingMethodId === shippingMethod.id}
               defaultChecked={fee.shippingMethodId === shippingMethod.id}
        />
        <label htmlFor={`shipping-${item.offerId}-${shippingMethod.id}`}>
          <p><strong>{shippingMethod.label}</strong></p>
        </label>
      </div>
    </div>
  );
};
